export const LOGIN_SUCCESS = 'login_success';
export const CLEAR_CACHE = 'clear_cache';

export const EXPIRED_TOKEN = 'expired_token';
